import { EventImportDialog } from '@/components/events/EventImportDialog';
import { EventsList } from '@/components/events';
import { PageContainer, type CrudListHeaderAction } from '@startupquickstart/frontend';
import { Upload } from 'lucide-react';
import { useMemo, useState } from 'react';

const breadcrumbs = [
  { label: 'Home', href: '/' },
  { label: 'Events', current: true },
];

export function EventsPage() {
  const [importOpen, setImportOpen] = useState(false);

  const headerActions = useMemo<CrudListHeaderAction[]>(
    () => [
      {
        key: 'import',
        label: 'Import',
        icon: Upload,
        variant: 'outline',
        onClick: () => setImportOpen(true),
      },
    ],
    [],
  );

  return (
    <PageContainer>
      <EventsList breadcrumbs={breadcrumbs} headerActions={headerActions} />
      <EventImportDialog open={importOpen} onOpenChange={setImportOpen} />
    </PageContainer>
  );
}
